module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "homepage"
    }
  }, [_c('navigation', {
    staticClass: "absolute"
  }), _vm._v(" "), _c('hero', {
    attrs: {
      "words": _vm.words,
      "subtitle": _vm.subtitle,
      "button": {
        link: 'portfolio',
        text: 'Check out my work'
      }
    }
  }), _vm._v(" "), _c('iam'), _vm._v(" "), _c('testimonials'), _vm._v(" "), _c('contact-me')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4235a78c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/pages/homepage.vue
// module id = 156
// module chunks = 0